import { DataContext } from "@/types";
import { Data } from "../Data";
import { SettingsRegulationDomain } from "./SettingsRegulationDomain";

export class SettingsRegulationDomainList extends Data {
  static instance: SettingsRegulationDomainList | null = null;
  domains: any;

  constructor(options: any) {
    const { apiUrl, ...otherOptions } = options;

    const apiOptions = {
      api: apiUrl,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...otherOptions
    };

    super(apiOptions);
    this.domains = [];
  }

  onDataReceived(data: any) {
    this.domains = [];
    data.regulationDomains.forEach((g: any, index: any) =>
      this.domains.push(new SettingsRegulationDomain(g))
    );
  }

  static onGetData(context: DataContext, options: any): Promise<SettingsRegulationDomainList> {
    const { apiUrl } = options;
    return new Promise((resolve, reject) => {
      SettingsRegulationDomainList.instance = new SettingsRegulationDomainList({
        apiUrl,
        resolve,
        reject,
        context
      });
    });
  }

  static getSettingsRegulationDomainList(context: DataContext, updateCache: boolean): Promise<SettingsRegulationDomainList> {
    return new Promise((resolve, reject) => {
      if (SettingsRegulationDomainList.instance && updateCache !== true)
        resolve(SettingsRegulationDomainList.instance);
      else
        SettingsRegulationDomainList.instance = new SettingsRegulationDomainList({
          resolve,
          reject,
          context
        });
    });
  }
}
